import { UtilityTeamMember } from "../../../../../model/utility-users/utility-team-member";
import styles from "./teammember.module.scss";

type TeamMemberRowProps ={
    User: UtilityTeamMember

}

 export const TeamMemberAvatar = (props : TeamMemberRowProps) => {
     
     return (
         <div className={styles.TeamMemberAvatar}>
            {props.User.firstName.charAt(0)}
         </div>
     );
 };
 